import { Document, Page, pdfjs } from "react-pdf";
import { useState, useEffect, useRef } from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';

const worker =  `/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = worker;

const WaiverViewer = ({ waiverPdfUrl }: { waiverPdfUrl: string }) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  const handlePageRender = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
  }, [pageNumber]);

  const pageWidth = Math.min(window.innerWidth * 0.9, 580);
  const fixedHeight = pageWidth * 1.214; // A4 ratio

  return (
    <Box
      ref={containerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: pageWidth,
          minHeight: fixedHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {/* {isLoading && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255,255,255,0.7)',
              zIndex: 10,
            }}
          >
            <Typography variant="body2">Loading page...</Typography>
          </Box>
        )} */}

        <Document
          file={waiverPdfUrl}
          onLoadSuccess={handleLoadSuccess}
          loading={<Typography>Loading PDF...</Typography>}
        >
          <Page
            key={pageNumber}
            pageNumber={pageNumber}
            width={pageWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            onRenderSuccess={handlePageRender}
          />
        </Document>
      </Box>

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ mt: 2, flexWrap: 'wrap', justifyContent: 'center' }}
      >
        <Button
          size="small"
          variant="outlined"
          onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
          disabled={pageNumber <= 1}
        >
          Previous
        </Button>

        <Typography variant="body2">
          Page {pageNumber} of {numPages ?? '?'}
        </Typography>

        <Button
          size="small"
          variant="outlined"
          onClick={() =>
            setPageNumber((p) => Math.min(p + 1, numPages ?? p))
          }
          disabled={pageNumber >= (numPages ?? 1)}
        >
          Next
        </Button>
      </Stack>
    </Box>
  );
};

export default WaiverViewer;
